export const CONFIGURATION_TABS = [{ value: "email", label: "Email" }] as const;

export type ConfigurationTab = (typeof CONFIGURATION_TABS)[number]["value"];
